import Layout from "../components/layout/Layout"
import NewsDetailsSection from "../components/sections/NewsDetailsSection"
export default function WhyWPCDoorsAreTheFutureOfIndianHomes() {
	return (
		<>
			<Layout headerStyle={1} footerStyle={1} breadcrumbTitle="Why WPC Doors Are the Future of Indian Homes ?">
				<NewsDetailsSection />
			</Layout>
		</>
	)
}
